<template>
  <Experiment title="expression-alternatives-rating-experiment">

    <InstructionScreen :title="'Welcome'">
      Thanks for taking part in our experiment! The experiment will take approximately 3-4 minutes.
      <br />
      <br />
      In this study would like to ask you to rate different sentences, some of which were generated by machines (large language models), and some by humans.
      The purpose of the ratings is to assess the quality of the machine generations, and your contribution will greatly help us to do so.
      We will NOT use your ratings to train any models, and will only use the ratings for evaluation purposes.
      <br />
      <br />
      You are participating in a study conducted by cognitive scientists at the University of Tübingen. 
      Your participation in this research is voluntary.
      You may decline to answer any or all of the following questions.
      You may decline further participation, at any time, without adverse consequences.
      <br />
      <br />
      Your anonymity is assured; the researchers who have requested your
      participation will not receive any personal information about you.
      <br />
      <br />
      By pressing the button 'Next' you confirm that you are at least 18 years old and agree to participate in this study. 
    </InstructionScreen>
    <InstructionScreen :title="'Instructions'">
      On each trial, you will be given a short description of a situation.
      Then, you will read five sentences.
      We will ask you to rate how natural you think each sentence is for talking about the given situation.
      You'll use sliders to answer the question. 
      <br />
      <br />
      Notice that there will also be simple <b>attention checking trials</b>. 
      You will recognize them immediately when you read the important text on each trial carefully -- those trials contain instructions for you to move the sliders in a certain way. 
      Please follow these instructions on the respective trial. 
      <br />
      <br />
      Please try to respond naturally and reasonably, do not overthink your ratings. <br />
      There will be an example trial on the next screen before the actual experiment starts, so you can familiarize yourself with the task.
    </InstructionScreen>

    <ParallelRatingScreenExample :itemOrder="['lower_bound', 'p1', 'p2', 'upper_bound', 'p3']" :trial_type="'example'"  />

    <template v-for="(trial, i) in trials">   
      <template v-if="Object.keys(trial).includes('correct_answer')"> 
        <ParallelRatingScreen 
            :trial=trial
            :index=i 
            :trial_type="'filler'" 
            :progress="i / trials.length" 
            :itemOrder="_.shuffle(['upper_bound', 'p1', 'p2', 'p3', 'lower_bound'])" 
            :correct_answer="trial.correct_answer"
        />   
      </template>
      <template v-else>
        <ParallelRatingScreen 
            :trial=trial
            :index=i 
            :trial_type="'main'" 
            :progress="i / trials.length" 
            :itemOrder="_.shuffle(['upper_bound', 'p1', 'p2', 'p3', 'lower_bound'])" 
            :correct_answer="'main'"
        />     
      </template> 
    </template>

    <CustomPostTestScreen />

    <SubmitResultsScreen />

  </Experiment>
</template>

<script>
import _ from 'lodash';
import trialsAll from '../trials/cs2_expressions_processed.csv';
import fillersAll from '../trials/fillers.csv';
import ParallelRatingScreen from './ParallelRatingScreen';
import ParallelRatingScreenExample from './ParallelRatingScreenExample';
import CustomPostTestScreen from './CustomPostTestScreen';

var group = _.sample(['odd', 'even']);
var conditions = _.shuffle(['s_typical', 's_typical', 's_typical', 's_typical', 's_typical', 's_atypical', 's_atypical', 's_atypical', 's_atypical', 's_atypical']);
var items = _.shuffle(['1', '4', '6', '8', '10', '13', '14', '16', '19', '20']);
const n_vignettes = 6;
const n_fillers = 1;

function filterByCondition(data) {
  const conditionMap = {}
  items.forEach((item, i) => {
    conditionMap[item] = conditions[i]
  })

  return data.filter(row => {
    return conditionMap[row.vignette] === row.state_type
  })
}
// const trials =
//   group == 'even' ? trialsAll.filter((element, index) => {
//        return index % 2 == 0;
//      }) :
//     //  trialsAll.filter((element, index) => {
//     //     return _.includes(["cafe-pie", "electronics-laptop", "plants-green", "furniture-outdoors"], element["itemName"]);
//     //   });
//   trialsAll.filter((element, index) => {
//        return index % 2 != 0;
//      });
const trials = filterByCondition(trialsAll);

const sampled_trials = _.sampleSize(trials, n_vignettes); //_.sampleSize(trials, n_vignettes).map(x => _.fill(Array(6), x)).flat()

// Disable selecting text
// Supported by the following browsers:
// https://caniuse.com/mdn-api_document_selectstart_event
document.onselectstart = () => false;

// Disable context menu
// Supported by the following browsers:
// https://caniuse.com/mdn-api_element_contextmenu_event
document.oncontextmenu = () => false;

export default {
  name: 'App',
  components: { 
    ParallelRatingScreen,
    ParallelRatingScreenExample,
    CustomPostTestScreen
   },
  data() {
    return {
      trials: _.shuffle(_.concat( sampled_trials, _.sampleSize(fillersAll, n_fillers))) 
    };
  },
  computed: {
    // Expose lodash to template code
    _() {
      return _;
    }
  }
};
</script>
<style>
body {
  /*
  Disable selecting text via css
  Supported by the following browsers
  https://caniuse.com/mdn-css_properties_user-select
  */
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
}
</style>
